/** The Cockpit's one-line score strip (OR-30.31): last year's verdict against the twin, the place, and the way to the full Results page. */
import type { RoundReport } from "@bsim/contracts";
import { verdictParts } from "../results/ResultsHero";
import type { HeroRank } from "../results/ResultsHero";
import { GxPill } from "../theme/GxPill";
import { Link } from "../shell/history";

export function ScoreStrip({ report, rank, href, breached }: { readonly report: RoundReport; readonly rank: HeroRank; readonly href: string; readonly breached: number }) {
  const verdict = verdictParts(report.score.valueCreatedUsdPerShare);
  return (
    <section className="gx-score-strip" data-testid="cockpit.score-strip" aria-label="Your result against your twin">
      <span className="gx-score-strip-verdict" data-testid="score.standing" data-side={verdict.side}>{verdict.lead}<b className="gx-num">{verdict.figure}</b>{verdict.tail}</span>
      {rank.text === null ? null : <span className="gx-muted" data-testid="results.rankmove">{rank.text}</span>}
      {breached > 0 ? <GxPill tone="warn" testId="results.hero.limits">{breached} {breached === 1 ? "limit" : "limits"} breached</GxPill> : null}
      <Link href={href} className="gx-score-strip-link" data-testid="cockpit.score-strip.link">See your results →</Link>
    </section>
  );
}
